import { Question } from "src/pods/pairshare/types";
import {
  RECEIVE_IDEAS,
  sendHideVideo,
  sendSeekOffset,
  sendVideoIsFullscreen,
  sendVideoPlaybackState,
  SEND_IDEAS,
} from "./data/display";
import { Slide } from "./data/types";
import { getBoardBySlug, getBoardSlugs } from "./boardCatalog";

export type Display = {
  watch: Slide | null;
  question: Question | null;
  isPlaying: boolean;
  isFullscreen: boolean;
  seekOffset: number;
};

export type IdeasState = {
  display: Display;
};

export const initialIdeasState: IdeasState = {
  display: {
    watch: null,
    question: null,
    isPlaying: false,
    isFullscreen: false,
    seekOffset: 0,
  },
};

export const selectBoardSlugs = () => getBoardSlugs();

export const selectBoardBySlug = (_state: unknown, boardSlug: string) => getBoardBySlug(boardSlug);

export { SEND_IDEAS, RECEIVE_IDEAS, sendHideVideo, sendVideoIsFullscreen, sendVideoPlaybackState, sendSeekOffset };
